import * as React from "react";
import {
    Grid,
    Paper,
    IconButton,
    Typography,
    Tooltip
} from "@material-ui/core";
import { inject, observer } from "mobx-react";
import DeleteIcon from "@material-ui/icons/Delete";
import BrushIcon from "@material-ui/icons/Brush";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import DoneIcon from "@material-ui/icons/Done";
import CancelIcon from "@material-ui/icons/Clear";
import { lighten, darken } from "@material-ui/core/styles/colorManipulator";
import Icon from "./Icon"
import LabelerSegmentationUiStore, { POINTS_MIN } from "../../../store/segmentation-store/labelerSegmentationUiStore";
import FabricSegmentationStore from "../../../store/segmentation-store/fabricSegmentationStore";
import LabelerSegmentationStore from "../../../store/segmentation-store/labelerSegmentationStore";

const Label = ({ label, index, labelerSegmentationUiStore, fabricSegmentationStore, labelerSegmentationStore }: any) => {


    const {
        tagSelectedIndex,
        setTagSelectedIndex,
        findPolygonNotDone,
        selectMode,
        closeCurrentPolygon,
        toggleVisibility,
        setOpenAlertDialog,
        setAlertDialogText,
        setAlertDialogCallback,
    } = labelerSegmentationUiStore as LabelerSegmentationUiStore

    const {
        toggleCanvasVisibility,
    } = fabricSegmentationStore as FabricSegmentationStore

    const {
        deleteSegmentByName,
        isReadOnly
    } = labelerSegmentationStore as LabelerSegmentationStore

    const [visibility, setVisibility] = React.useState<boolean>(true)

    const isSelected = tagSelectedIndex === index;
    const disabledIcon = label.occurences === 0;
    const polygonNotDone = findPolygonNotDone();
    const isThisPolygonNotDone = polygonNotDone?.labelValue?.startsWith(label.legend);
    const disabledCancel = selectMode || (!isSelected && polygonNotDone && !isThisPolygonNotDone);
    const disabledEdit =
      isReadOnly ||
      disabledCancel ||
      polygonNotDone?.points?.length < POINTS_MIN;

    /// HANDLERS //////////////

    const handleEdit = () => {
        if (disabledEdit)
            return;
        setTagSelectedIndex(index)
    }

    const handleVisibility = () => {
        const name = label.legend
        setVisibility(!visibility)
        toggleVisibility(name, !visibility);
        setTimeout(() => {
            toggleCanvasVisibility(name, !visibility);
        }, 100)
    }

    const handleDelete = () => {
        setAlertDialogText("Êtes-vous sur de vouloir supprimer toutes les labellisations de cette classe ?")
        setAlertDialogCallback(() => { deleteSegmentByName(label.legend) });
        setOpenAlertDialog(true);
    }

    const handleClosePolygon = () => {
        closeCurrentPolygon();
    }

    const handleCancelPolygon = () => {
        setAlertDialogText("Êtes-vous sur de vouloir annuler la labellisation en cours ?")
        setAlertDialogCallback(() => {
            const polyNotDone = findPolygonNotDone();
            if (polyNotDone) {
                deleteSegmentByName(polyNotDone.labelValue)
            }
        });
        setOpenAlertDialog(true);
    }

    ///////////////////////////

    return (
        <Grid container>

            {/* LABEL */}
            <Grid item xs={12}>
                <Paper 
                    style={{
                        backgroundColor: lighten(label.color, isSelected ? 0.6 : 0.98),
                        border: `2px solid ${lighten(label.color, isSelected ? 0 : 0.5)}`,
                        padding: '8px',
                        borderRadius: "10px",
                        cursor: isReadOnly || disabledEdit ? "default" : "pointer",
                    }}
                    onClick={isReadOnly ? undefined : handleEdit}
                >
                    <Grid container>
                        <Grid item xs={11}>
                            <Typography>{label.legend}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography>{label.occurences}</Typography>
                        </Grid>
                    </Grid>
                    
                    
                </Paper>
            </Grid>

            {/* ACTIONS  */}
            <Grid 
                item 
                container 
                style={{
                    marginBottom: "8px",
                    height: 40
                }}
                xs={12}
            >
                {!isReadOnly &&
                <>
                <Grid 
                    item 
                    container
                    xs={4}
                    justify="flex-start"
                    style={{
                        padding: "4px 2px"
                    }}
                >
                    {polygonNotDone && isThisPolygonNotDone && 
                        <>
                        <Icon 
                            title="Valider la labelisation en cours"
                            disabled={disabledEdit}
                            color={!disabledEdit ? "green" : ""}
                            component={DoneIcon}
                            onClick={handleClosePolygon}/>
                        <Icon 
                            title="Annuler la labelisation en cours" 
                            disabled={disabledCancel}
                            color={!disabledCancel ? "red" : ""}
                            component={CancelIcon}
                            onClick={handleCancelPolygon}/>    
                        </>
                    }
                </Grid>
                <Grid 
                    item
                    container
                    xs={8} 
                    justify="flex-end"
                    style={{
                        padding: "4px 2px"
                    }}
                >
                    <Icon 
                        title="Labelliser" 
                        disabled={disabledEdit}
                        color={!selectMode && isSelected ? label.color : ""}
                        component={BrushIcon} 
                        onClick={handleEdit}/>
                    <Icon 
                        title={`${visibility ? "Cacher" : "Afficher"} les labellisations`} 
                        disabled={disabledIcon}
                        component={visibility ? VisibilityIcon : VisibilityOffIcon} 
                        onClick={handleVisibility}
                    />
                    <Icon 
                        title="Supprimer les labellisations de cette classe" 
                        // disabled={!selectMode || disabledIcon}
                        disabled={disabledIcon}
                        component={DeleteIcon} 
                        onClick={handleDelete}/>
                </Grid>
                </>
                 }
            </Grid>
        </Grid>
        
    )
}

export default inject("labelerSegmentationUiStore", "fabricSegmentationStore", "labelerSegmentationStore")(observer(Label))